import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { AdminUrls } from '../../network/config';
import { removeData } from '../../store/action';
import Loader from '../../_components/loader';

const NumberOfCpd_Url = AdminUrls.ADMIN.NUMBEROFCPDQUEUE;
const cpdHome_Url = AdminUrls.COMMON.HOME;

class AdminHome extends React.Component {
  constructor() {
    super();
    this.numberOfQueue = this.numberOfQueue.bind(this);
    this.dashboardContentHandler = this.dashboardContentHandler.bind(this);

    this.state = {
      queuecount: '',
      dashboardContent: [],
      mainLoading: false,
    };
    this.controller = new AbortController();
  }

  componentDidMount() {
    this.numberOfQueue();
    this.dashboardContentHandler();
  }

  dashboardContentHandler() {
    this.setState({
      mainLoading: true,
    });
    axios
      .get(cpdHome_Url, {
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          dashboardContent: response?.data,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  numberOfQueue() {
    axios
      .get(NumberOfCpd_Url, {
        method: 'GET',
        withCredentials: true,
        signal: this.controller.signal,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          queuecount: response?.data,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    return (
      <div>
        <div>
          <section id="portfolio" className="smallfont ng-scope">
            <div>
              <div className="row">
                {this.state.mainLoading && <Loader />}
                {this.state.dashboardContent &&
                this.state.dashboardContent?.length
                  ? this.state.dashboardContent.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="col-xs-12 col-sm-6 col-md-4 portfolio-item"
                        >
                          <Link to={item?.Action.toLowerCase()}>
                            <div className="panel panel-default">
                              <div className="panel-heading panel-heading-cpd ng-binding">
                                {item?.FeatureName}{' '}
                                {item?.FeatureID === 3 ? (
                                  <span className="label label-danger">
                                    {this?.state?.queuecount}
                                  </span>
                                ) : (
                                  ''
                                )}
                              </div>
                              <div className="panel-body">
                                <img
                                  id="mycpd"
                                  width="100"
                                  height="100"
                                  alt=""
                                  src={
                                    process.env.PUBLIC_URL +
                                    item?.Face.replace('app/images', '/images')
                                  }
                                />
                              </div>
                              <div className="panel-footer cpdfooter ng-binding">
                                {item?.FeatureDesc}
                              </div>
                            </div>
                          </Link>
                        </div>
                      );
                    })
                  : ''}
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AdminHome);
